const conf={
  apiUrl:'https://back.lescapucins.org',
  authToken: 'JyRPzcQhMjKqnYS84NAj',
}
export default conf;
